import React from 'react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import config from './utils/config';
import getNonAuthLDConfig from './getNonAuthLDConfig';

/*
  Initializes the LaunchDarkly React SDK and returns a provider.
*/

const FeatureFlagsProvider: React.FC<any> = ({ children }) => {
  return children;
};

const getProviderComponent = (): any => {
  if (config.launchDarkly?.defaultUserKey) {
    const configObject = getNonAuthLDConfig();
    return withLDProvider(configObject)(FeatureFlagsProvider);
  }
  return FeatureFlagsProvider;
};

export default getProviderComponent();
